const listPointsBody = document.querySelector('#viewChats').querySelector('div[name=body]').querySelector('div[name=profileLenta]');
// const listPointsBody = document.querySelector('#viewChats').querySelector('div[name=body]').querySelector('div[name=profileLenta]');

import auth from '../../tools/storage.js';
// import auth from '../../tools/storage.js';

import toolsMarkup from '../../markup/tools.js';
import tools from '../../tools/tools.js';


let cardProfile = '';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = `
    <div class="profileLenta-cloud column">
        <b class="m-auto">Выберите чат слева!</b>
    </div>
    `;
  },


  loadContainer(dataProfile) {
    const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner('', 'Загрузка...');

    console.log(dataProfile);

    let manager = dataProfile.mail;

    if (dataProfile.detail.nameF) {
      manager = dataProfile.detail.nameF;

      if (dataProfile.detail.nameI)
        manager += ' ' + dataProfile.detail.nameI + ' ';

      if (dataProfile.detail.nameO)
        manager += ' ' + dataProfile.detail.nameO;

    } else if (dataProfile.detail.name) {
      manager = dataProfile.detail.name;
    }

    let imgProfile = '';

    if(dataProfile.detail.image){
      imgProfile = ` <img src="https://storage.yandexcloud.net/fest-content-0/creators/${dataProfile.detail.image}.jpg"  class="profileImg shimmer">`;

    }

    cardProfile = `<div class="profileLenta-cloud-main row m-0 ">
        ${imgProfile}
        <div class="title w-100">${manager}</div>
        <little class="w-30">Телефон:</little> <b  class="w-70">${dataProfile.phone ? tools.formatedPhone(dataProfile.phone) : ''}</b>
        <little class="w-30">E-mail:</little><b  class="w-70">${dataProfile.mail ? dataProfile.mail : ''}</b>
        <little  class="w-40">Дата регистрации:</little><b  class="w-60 txt-al-right">${dataProfile.regTime ? tools.dateStringFull(dataProfile.regTime) : ''}</b>
        <little  class="w-40">Дата активность:</little><b  class="w-60 txt-al-right">${dataProfile.lastActivity ? tools.dateStringFull(dataProfile.lastActivity) : ''}</b>
        <little class= "w-50">Telegram-bot </little><b class="w-50 txt-al-right">${dataProfile.telegramStatus== 9 ? 'подключен' :'не подключен'}</b>
        `

      if(dataProfile.detail && dataProfile.detail.site){
        cardProfile += `<little  class="w-20">Сайт:</little><b  class="w-80 txt-al-right"><a href="${dataProfile.detail.site}" target="_blank">${dataProfile.detail.site}</a></b>`;
      }
    cardProfile += `</div>`;

    listPointsBody.innerHTML = `
    <div class="profileLenta-cloud column">
      ${cardProfile}
      <br>
      <div class="txt-al-center">Заявки:</div>
      <br>
      ${loaderSpinnerMarkup}
    </div>
    `;
  },

  cleanchatsContainer() {
    listPointsBody.innerHTML = `
        <div class="profileLenta-cloud column">
          ${cardProfile}
          <br>
          <div class="txt-al-center">Заявки:</div>
        </div>`;

  },

  drawChatsInContainer(data, currentChat) {
    let allChats = '';
    let workNameBefore = '';
    let countWarning = 1;

    if(data)
      data.forEach((item, index) => {
        if(workNameBefore != item.filmName){
          allChats += `</div> <div class="cloud-one-work">
                      <div class="row m-0 p-1">
                        <b class="w-90"> ${item.filmName}</b>
                        <button class="btn btn-light w-10" name="openCard"  filmID="${item.filmID}">...</button>
                      </div>`;
          workNameBefore = item.filmName;
          countWarning = 1;
        }

          let nameChat = 'Основной чат по заявке';

          if(item.cffrBlockID != 'chat'){
            nameChat = `Замечание №${countWarning}`;
            ++countWarning;
          }


          let curChat = '';
          if(item.cffrID == currentChat)
            curChat = 'currentChat';

          allChats += `<div class="oneChat ${curChat}" chatID="${item.cffrID}" name="openDialog"> 
                        ${nameChat}
                      </div>`;
      });

    allChats += `</div>`;

    listPointsBody.innerHTML = `
        <div class="profileLenta-cloud column">
          ${cardProfile}
          <br>
          <div class="txt-al-center">Заявки:</div>
          <br><div>
          ${allChats}
        </div>`;
  },

  getElement(item, index) {
    
    

    listPointsBody.innerHTML = `
    <div class="profileLenta-cloud column">
      <div class="profileLenta-cloud-main row m-0 ">
        <div class="title w-100"> </div>
        <little class="w-30">Телефон:</little> <b  class="w-70"> </b>
        <little class="w-30">E-mail:</little><b  class="w-70"> </b>
        <little  class="w-50">Дата регистрации:</little><b  class="w-50"> </b>
        <little  class="w-50">Дата активность:</little><b  class="w-50"> </b>

      </div>
    </div>`;

    return `<div class="mainLenta-cloud ${newMsg}" ${fcID}> 
            <div  class="title"> 
              ${manager}
            </div>  
            <label ${fcID}> ${item.lastchat}</label>
            <little>${item.maxTimeChat}</little>
          </div>`;
  },

  drawDataInContainer(listWithData) {
    this.cleanContainer();
    let HTMLBODY = '';

    if (listWithData) {
    
      listWithData.forEach((item, index) => {
        HTMLBODY += this.getElement(item, index);
      });
      listPointsBody.innerHTML = HTMLBODY;
    } else
      listPointsBody.innerHTML = ' - - - ';
  },


  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
